import { IStackStyles, IStackItemStyles, IPivotStyles, IPalette } from '@fluentui/react';

export const gridItemStyle = (): IStackStyles => {
  return {
    root: {
      overflow: 'visible',
      minWidth: 'calc(100% / 3 - 1.5rem)'
    }
  };
};

export const lookupItemStyle = (palette: IPalette): Partial<IStackItemStyles> => {
  return {
    root: {
      position: 'relative',
      selectors: {
        '::before': {
          position: 'absolute',
          bottom: 0,
          left: 0,
          background: palette.neutralLight,
          height: 2,
          width: '100%',
          content: `''`
        }
      }
    }
  };
};

export const pivotStyle = (palette: IPalette): Partial<IPivotStyles> => {
  return {
    root: {
      paddingLeft: '3rem',
      selectors: {
        '::before': {
          position: 'absolute',
          bottom: 0,
          left: 0,
          background: palette.neutralLight,
          height: 2,
          width: '100%',
          content: `''`
        }
      }
    }
  };
};
